import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import MarkdownRenderer from "react-markdown-renderer";
import {
  GET_DASHBOARD_DATA,
  NEW_DAHSBOARD_PAGE_DATA_URL,
} from "../../utils/urlconfig.js";
import { getMinMaxCoordinates } from "../../utils/helpers.js";
import CustomBarChart from "../../common/custom-bar-chart/custom-bar-chart";
import CustomPieChart from "../../common/custom-pie-chart/custom-pie-chart";
import CustomLineChart from "../../common/custom-line-chart/custom-line-chart";
import DataService from "../../utils/dataservice.js";
import LocationMap from "../../common/custom-map/custom-map.js";
import LoadChartBasedOnType from "../question-based-graph/load-chart-based-on-type.js";
import GenericChart from "../../common/custom-generic-chart/custom-generic-chart.js";
import Accordion from "react-bootstrap/Accordion";
import {
  salesTypeTemplatesList,
  supplyChainTypeTemplatesList,
  supplyChainInsights,
  salesTypeInsights,
} from "./dashboardStaticData.js";

import "./dashboard.css";
import { Insights } from "@mui/icons-material";

export default function (props) {
  const navigate = useNavigate();

  const [isLoading, setIsLoadng] = useState(true);
  const [dashboardPageData, setDashboardPageData] = useState({});
  const [isEnabled, setIsEnabled] = useState(false);

  const [templatesList, setTemplatesList] = useState([]);
  const [finalChartsData, setFinalChartsData] = useState([]);
  const userType = localStorage.getItem("userType");
  const [currentActiveTemplate, setCurrentActiveTemplate] = useState(
    userType === "Sales" ? "Sales_and_Revenue_Growth" : "Inventory_Management"
  );
  const colorsList = [
    "#033666",
    "#00D1FF",
    "#0068A7",
    "#0092CA",
    "#00A7DC",
    "#03457B",
    "#01B2F5",
    "#0077B3",
    "#00B5E4",
    "#00C6F2",
    "#023E73",
    "#02A9F2",
    "#0083C2",
    "#00D9F5",
  ];

  const insightQueryOne = `How do the sales vary across different classes of markets over time?`;
  const insightQueryTwo = `How do the sales vary across different classes of markets over time?`;
  const questionsList = [
    "Give me Class of Mkt wise average month on month growth of Quantity from April to June in product GAJ",
    "Give me RO type wise average market share change for OMC MUWE during April to June for Product SH",
    "Give me the list of top 10 districts basis the average month on Month increase from April to June",
    "Give me the list of Regional Office where OMC VUEQ has increased market share from April to May",
  ];
  const [isEnabledInsight, setIsEnabledInsight] = useState(false);
  const [isLoadingInsight, setIsLoadingInsight] = useState(true);
  const [insightQuery, setInsightQuery] = useState(
    currentActiveTemplate === "Sales_and_Revenue_Growth"
      ? insightQueryOne
      : insightQueryTwo
  );
  const [insightsText, setInsightText] = useState("");

  const handleOnTemplateSelection = (template) => {
    if (template.templateValue !== "Custom Dashboard") {
      template.value === "Sales_and_Revenue_Growth"
        ? setInsightQuery(insightQueryOne)
        : setInsightQuery(insightQueryTwo);
      setCurrentActiveTemplate(template.templateValue);
      let tempList = [...templatesList];

      tempList.forEach((element) => {
        if (element.templateName === template.templateName) {
          element.isActive = true;
        } else {
          element.isActive = false;
        }
      });
      setTemplatesList(tempList);
    } else {
      navigate("/question-based-graph?queryFlag=false");
    }
  };

  const handleAPICallTogetData = (templateValue = currentActiveTemplate) => {
    if (currentActiveTemplate && currentActiveTemplate !== "Custom Dashboard") {
      setIsLoadng(true);
      setIsEnabled(true);
      setIsEnabledInsight(true);
      setIsLoadingInsight(true);
    }
  };

  // New useEffect to monitor dashboardPageData
  useEffect(() => {
    if (Object.keys(dashboardPageData).length > 0) {
      setIsLoadng(false);
    }
  }, [dashboardPageData]);

  // For initial load
  useEffect(() => {
    if (localStorage.getItem("userType") === "Sales") {
      setTemplatesList(salesTypeTemplatesList);
    } else {
      setTemplatesList(supplyChainTypeTemplatesList);
    }
    handleAPICallTogetData();
  }, []);

  useEffect(() => {
    if (
      currentActiveTemplate !== "Sales_and_Revenue_Growth" ||
      currentActiveTemplate !== "Inventory_Management"
    ) {
      handleAPICallTogetData();
    }
  }, [currentActiveTemplate]);

  const getDashboardDataRequestPayload = () => {
    return {
      templateType: currentActiveTemplate,
      userType: localStorage.getItem("userType"),
    };
  };

  const getInsigtDataByLabel = (chartname) => {
    const insightList =
      currentActiveTemplate === "Sales_and_Revenue_Growth"
        ? [...salesTypeInsights]
        : [...supplyChainInsights];
    let filteredItem = insightList.filter(
      (ele) => ele.name.toLocaleLowerCase() === chartname.toLocaleLowerCase()
    );

    return filteredItem[0].insight;
  };

  const convertXAxisToStrings = (dataArray) => {
    dataArray.forEach((item, index) => {
      item["question"] = questionsList[index];

      item["insightDetails"] = getInsigtDataByLabel(item.data.chartName);
      const xAxis = item.data.xAxis;
      xAxis.forEach((axis) => {
        axis.data = axis.data.map((value) => String(value));
      });
    });

    return dataArray;
  };

  return (
    <>
      <DataService
        url={`${NEW_DAHSBOARD_PAGE_DATA_URL}dashboard_chart?usertype=${userType}&templatetype=${currentActiveTemplate}`}
        isDashBoardUrl={true}
        method="POST"
        isEnabled={isEnabled}
        data={null}
        onSuccess={(data) => {
          // data["response"] = setInsightTextBasedOnTemplateType(
          //   currentActiveTemplate
          // );

          setFinalChartsData(convertXAxisToStrings(data));

          setIsLoadng(false);
          setIsEnabled(false);
        }}
        onError={(e) => {
          setIsLoadng(false);
          console.log("Error in loading dashboard data", e);
          setIsEnabled(false);
        }}
      />

      <DataService
        url={`https://ai-workbench.aisf.t-systems.net/api/insights_from_DB/v1/recommendations_lengthy`}
        isDashBoardUrl={false}
        method="POST"
        isEnabled={false}
        data={{
          query: insightQuery,
        }}
        onSuccess={(data) => {
          setInsightText(data.detail);
          setIsEnabledInsight(false);
          setIsLoadingInsight(false);
        }}
        onError={(e) => {
          setIsEnabledInsight(false);
          setIsLoadingInsight(false);
        }}
      />

      <div className="dashbord-container w-100 p-3 pt-0">
        <div className="dashbord-page-content p-0">
          <div className="dash-board-templates d-flex">
            {templatesList.map((template, index) => (
              <div
                className={`
                dash-template
                ${template.isActive ? "template-active" : ""}
                ${!template.templateValue ? "disable-template" : ""}
                ${index === 0 ? "first-template" : ""}
                ${index === templatesList.length - 1 ? "last-template" : ""}
              `}
                key={index}
                onClick={() => handleOnTemplateSelection(template)}
              >
                {template.templateName}
              </div>
            ))}
          </div>
          {isLoading ? (
            <div className="dash-heading mt-3"> Loading dashboard data ...</div>
          ) : (
            <div className="dashbord-page-top-cards float-start mt-3 position-relative w-100">
              {finalChartsData.length > 0 &&
                finalChartsData.map((chart, index) => (
                  <div className="w-100 float-start">
                    <div
                      key={index}
                      className="mb-2 dashbord-page-top-cards position-relative chartsBox"
                      style={{
                        float: index % 2 === 0 ? "left" : "right",
                      }}
                    >
                      <div
                        className="chart-heading"
                        style={{ color: "#033666" }}
                      >
                        {chart.data.chartName}
                      </div>
                      {chart.data.yAxis[0] &&
                      chart.data.yAxis[0].type.toLowerCase() === "pie" ? (
                        <div className="pie-chart-legends" style={{}}>
                          {chart.data.xAxis[0].data.map((legend, index) => (
                            <div>
                              <div className="d-flex ">
                                <div
                                  className="legend-icon"
                                  style={{
                                    height: "20px",
                                    width: "20px",
                                    marginRight: "10px",
                                    backgroundColor: colorsList[index],
                                  }}
                                ></div>
                                <div className="legen-label">{legend}</div>
                              </div>
                            </div>
                          ))}
                        </div>
                      ) : null}
                      <GenericChart chartData={chart.data} />
                    </div>
                    <div
                      className="insights-container"
                      style={{
                        width: "65%",
                        marginLeft: index % 2 === 0 ? "20px" : "0px",
                        float: index % 2 === 0 ? "right" : "left",
                      }}
                    >
                      <Accordion defaultActiveKey="0">
                        <Accordion.Item eventKey="0">
                          <Accordion.Header>Insights </Accordion.Header>
                          <Accordion.Body>
                            {!chart.insightDetails ? (
                              <div className="dash-heading">
                                Loading Insight ...{" "}
                              </div>
                            ) : (
                              <MarkdownRenderer
                                markdown={chart.insightDetails}
                              />
                            )}
                          </Accordion.Body>
                        </Accordion.Item>
                      </Accordion>
                    </div>
                  </div>
                ))}
            </div>
          )}
          {/* {!isLoadingInsight ? (
            <div>
              <div className="mt-3 mb-2 dash-heading">Overall Insights :</div>
              <MarkdownRenderer markdown={insightsText} />
            </div>
          ) : (
            <div className="dash-heading"> Loading Insights...</div>
          )} */}
        </div>
      </div>
    </>
  );
}
